import {
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col, CustomInput, DropdownItem, DropdownMenu, DropdownToggle,
    Input, ModalBody,
    Row, UncontrolledDropdown,
} from "reactstrap";
import React, {Fragment, useEffect, useState} from "react";
import {ArrowLeft, ArrowRight, MoreVertical, Plus, X} from "react-feather";
import Select from "react-select";
import {selectThemeColors} from "../../../utility/Utils";
import {useHistory, useParams} from "react-router-dom";
import {useDispatch, useStore} from "react-redux";
import axios from "axios";

import '../../../@core/scss/react/libs/flatpickr/flatpickr.scss';
import Flatpickr from "react-flatpickr";
import DataTable from "react-data-table-component";
import NewSponzorModal from "./NewSponzorModal";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import FooterButtons from "../../components/FooterButtons";
import CustomHeader from "../../CustomHeader";
import {Date_toYMD} from "../../../utility/DateUtility";

const MySwal = withReactContent(Swal)

export const disciplinePlivanje =
    [
        {label: "4X50M SLOBODNO ŠTAFETA", value: "4X50M SLOBODNO ŠTAFETA"},
        {label: "50M LEĐNO", value: "50M LEĐNO"},
        {label: "100M PRSNO", value: "100M PRSNO"},
        {label: "50M LEPTIR", value: "50M LEPTIR"},
        {label: "100M SLOBODNO", value: "100M SLOBODNO"},
        {label: "100M LEĐNO", value: "100M LEĐNO"},
        {label: "50M PRSNO", value: "50M PRSNO"},
        {label: "100M LEPTIR", value: "100M LEPTIR"},
        {label: "50M SLOBODNO", value: "50M SLOBODNO"},
        {label: "4X50M MJEŠOVITO ŠTAFETA", value: "4X50M MJEŠOVITO ŠTAFETA"},
        {label: '100M MJEŠOVITO', value: '100M MJEŠOVITO'},
    ];

export const disciplineAtletikaM = [
    {
        label: "100 M",
        value: "100 M"
    },
    {
        label: "400 M",
        value: "400 M"
    },
    {
        label: "1500 M",
        value: "1500 M"
    },
    {
        label: "SKOK U DALJ",
        value: "SKOK U DALJ"
    },
    {
        label: "SKOK U VIS",
        value: "SKOK U VIS"
    },
    {
        label: "BACANJE KUGLE",
        value: "BACANJE KUGLE"
    },
    {
        label: "4X100 M",
        value: "4X100 M"
    },
    {
        label: "4X100 M ŠTAFETA",
        value: "4X100 M ŠTAFETA"
    }
]

export const disciplineAtletikaZ = [
    {
        label: "100 M",
        value: "100 M"
    },
    {
        label: "400 M",
        value: "400 M"
    },
    {
        label: "1500 M",
        value: "1500 M"
    },
    {
        label: "SKOK U DALJ",
        value: "SKOK U DALJ"
    },
    {
        label: "SKOK U VIS",
        value: "SKOK U VIS"
    },
    {
        label: "BACANJE KUGLE",
        value: "BACANJE KUGLE"
    },
    {
        label: "4X100 M",
        value: "4X100 M"
    }
]

export const karateZ = [
    {
        label: "-50KG",
        value: "-50KG"
    },
    {
        label: "-55KG",
        value: "-55KG"
    },
    {
        label: "-61KG",
        value: "-61KG"
    },
    {
        label: "-68KG",
        value: "-68KG"
    },
    {
        label: "+68KG",
        value: "+68KG"
    },
    {
        label: "KATE",
        value: "KATE"
    }
];

export const karateM = [
    {
        label: "-60KG",
        value: "-60KG"
    },
    {
        label: "-67KG",
        value: "-67KG"
    },
    {
        label: "-75KG",
        value: "-75KG"
    },
    {
        label: "-84KG",
        value: "-84KG"
    },
    {
        label: "+84KG",
        value: "+84KG"
    },
    {
        label: "KATE",
        value: "KATE"
    }
];

export const judoM = [
    {
        label: "-60KG",
        value: "-60KG"
    },
    {
        label: "-66KG",
        value: "-66KG"
    },
    {
        label: "-73KG",
        value: "-73KG"
    },
    {
        label: "-81KG",
        value: "-81KG"
    },
    {
        label: "-90KG",
        value: "-90KG"
    },
    {
        label: "-100KG",
        value: "-100KG"
    },
    {
        label: "+100KG",
        value: "+100KG"
    }
];

export const judoZ = [
    {
        label: "-48KG",
        value: "-48KG"
    },
    {
        label: "-52KG",
        value: "-52KG"
    },
    {
        label: "-57KG",
        value: "-57KG"
    },
    {
        label: "-63KG",
        value: "-63KG"
    },
    {
        label: "-70KG",
        value: "-70KG"
    },
    {
        label: "-78KG",
        value: "-78KG"
    },
    {
        label: "+78KG",
        value: "+78KG"
    }
];

export const KickBoxingM = [
    {
        label: "K1 -67KG",
        value: "K1 -67KG"
    },
    {
        label: "K1 -71KG",
        value: "K1 -71KG"
    },
    {
        label: "K1 -75KG",
        value: "K1 -75KG"
    },
    {
        label: "K1 -81KG",
        value: "K1 -81KG"
    },
    {
        label: "K1 -86KG",
        value: "K1 -86KG"
    },
    {
        label: "LC +84KG",
        value: "LC +84KG"
    },
    {
        label: "LC -63KG",
        value: "LC -63KG"
    },
    {
        label: "LC -74KG",
        value: "LC -74KG"
    },
    {
        label: "LC -84KG",
        value: "LC -84KG"
    },
    {
        label: "PF +84KG",
        value: "PF +84KG"
    },
    {
        label: "PF -63KG",
        value: "PF -63KG"
    },
    {
        label: "PF -74KG",
        value: "PF -74KG"
    },
    {
        label: "PF -84KG",
        value: "PF -84KG"
    },
];

export const KickBoxingZ = [
    {
        label: "K1 -56KG",
        value: "K1 -56KG"
    },
    {
        label: "K1 -60KG",
        value: "K1 -60KG"
    },
    {
        label: "K1 -65KG",
        value: "K1 -65KG"
    },
    {
        label: "LC +65KG",
        value: "LC +65KG"
    },
    {
        label: "LC -55KG",
        value: "LC -55KG"
    },
    {
        label: "LC -65KG",
        value: "LC -65KG"
    },
    {
        label: "PF +65KG",
        value: "PF +65KG"
    },
    {
        label: "PF -55KG",
        value: "PF -55KG"
    },
    {
        label: "PF -65KG",
        value: "PF -65KG"
    },
];


export const TaekwondoM = [
    {
        label: "Slobodni stil Poomsae",
        value: "Slobodni stil Poomsae"
    },
    {
        label: "Kyorugi +54 do 58 kg",
        value: "Kyorugi +54 do 58 kg"
    },
    {
        label: "Kyorugi +58 do 63 kg",
        value: "Kyorugi +58 do 63 kg"
    },
    {
        label: "Kyorugi +63 do 68 kg",
        value: "Kyorugi +63 do 68 kg"
    },
    {
        label: "Kyorugi +68 do 74 kg",
        value: "Kyorugi +68 do 74 kg"
    },
    {
        label: "Kyorugi +74 do 80 kg",
        value: "Kyorugi +74 do 80 kg"
    },
    {
        label: "Kyorugi +80 do 87 kg",
        value: "Kyorugi +80 do 87 kg"
    },
    {
        label: "Kyorugi +87 kg",
        value: "Kyorugi +87 kg"
    },
    {
        label: "Kyorugi -54 kg",
        value: "Kyorugi -54 kg"
    },
    {
        label: "Poomsae",
        value: "Poomsae"
    },
]

export const TaekwondoZ = [
    {
        label: "Slobodni stil Poomsae",
        value: "Slobodni stil Poomsae"
    },
    {
        label: "Kyorug +46 do 49 kg",
        value: "Kyorug +46 do 49 kg"
    },
    {
        label: "Kyorugi +49 do 53 kg",
        value: "Kyorugi +49 do 53 kg"
    },
    {
        label: "Kyorugi +53 do 57 kg",
        value: "Kyorugi +53 do 57 kg"
    },
    {
        label: "Kyorugi +57 do 62 kg",
        value: "Kyorugi +57 do 62 kg"
    },
    {
        label: "Kyorugi +62 do 67 kg",
        value: "Kyorugi +62 do 67 kg"
    },
    {
        label: "Kyorugi +67 do 73 kg",
        value: "Kyorugi +67 do 73 kg"
    },
    {
        label: "Kyorugi +73 kg",
        value: "Kyorugi +73 kg"
    },
    {
        label: "Kyorugi -46 kg",
        value: "Kyorugi -46 kg"
    },
    {
        label: "Pomase",
        value: "Pomase"
    },
]


const DetaljiNatjecanjaStep2 = (props) => {
    const history = useHistory();
    const [competition, setCompetition] = useState(false);
    const [isNewSponsorModalOpen, setIsNewSponsorModalOpen] = useState(false);
    const store = useStore();
    const params = useParams();

    const [natjecanjeLocation, setNatjecanjeLocation] = useState("");
    const [natjecanjePlace, setNatjecanjePlace] = useState("");
    const [sequence, setSequence] = useState("");
    const [sequenceNumber, setSequenceNumber] = useState("");
    const [sponsors, setSponsors] = useState([]);
    const [competitionTeams, setCompetitionTeams] = useState(null);
    const [editSponsor, setEditSponsor] = useState(null)
    const [izabraneDisciplinePlivanjeAtletika, setIzabraneDisciplinePlivanjeAtletika] = useState("")
    const [validationFailed, setValidationFailed] = useState(false);
    const [note, setNote] = useState("");

    const handleGooglePlaces = () => {
        if (document.getElementById("lokacija-natjecanja-input") == null) {
            return;
        }
        let input = document.getElementById("lokacija-natjecanja-input");
        let myScript = document.createElement("script");
        myScript.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBLJTaZ8EX8QV22uA6qis_wKpT-dZbmad8&libraries=places&callback=initMap";
        myScript.onload = () => {
            const options = {
                fields: ["formatted_address", "adr_address", "geometry", "name"],
            };
            const autocomplete = new google.maps.places.Autocomplete(input);
            autocomplete.addListener("place_changed", (e) => {
                setNatjecanjeLocation(input.value);
                let place = autocomplete.getPlace();
                place.fullName = input.value;
                setNatjecanjePlace(place);
            });
        }
        myScript.className = 'search-script';
        myScript.id = 'search-script-google-detalji-natjecanja';
        document.body.appendChild(myScript);
    }

    const columns = [
        {
            name: 'Naziv',
            selector: 'name',
            sortable: true
        },
        {
            name: 'Vrsta',
            selector: 'typeOf',
            sortable: true
        },
        {
            name: 'Akcije',
            cell: row => (
                <UncontrolledDropdown>
                    <DropdownToggle tag='div' className='btn btn-sm'>
                        <MoreVertical size={14} className='cursor-pointer'/>
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem
                            className='w-100'
                            onClick={() => {
                                setEditSponsor(row);
                                setIsNewSponsorModalOpen(true)
                            }}
                        >
                            <span className='align-middle'>Izmijeni</span>
                        </DropdownItem>
                        <DropdownItem
                            className='w-100'
                            onClick={() => {
                                axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/delete-sponsor`, {
                                    sponsorId: row._id,
                                    competition: competition._id,
                                    competitionId: competition._id
                                }).then(() => {
                                    let sponsorsNew = sponsors.filter((oneSponsor) => {
                                        return oneSponsor._id !== row._id;
                                    })
                                    setSponsors([...sponsorsNew]);
                                    MySwal.fire({
                                        icon: 'success',
                                        title: 'Uspješno',
                                        text: 'Sponzor izbrisan',
                                        customClass: {
                                            confirmButton: 'btn btn-success'
                                        }
                                    })
                                }).catch((e) => {
                                    window.alert("Nesto je poslo po krivu. Probajte ponovno")
                                })
                            }}
                        >
                            <span className='align-middle'>Izbriši</span>
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            )
        }
    ]

    function initMap(e) {
    }

    useEffect(() => {
        function initMap(e) {
        }

        if (!competition) {
            axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/get-one-competition?competitionId=${params.id}`).then((firstResult) => {
                setCompetition(firstResult.data.competition);
                if (firstResult.data.competition.sponsors && firstResult.data.competition.sponsors.length > 0) {
                    setSponsors(firstResult.data.competition.sponsors);
                }

                let locationItem = firstResult.data.competition.location;
                if (locationItem) {
                    if (typeof locationItem === "object") {
                        let div = document.createElement("div");
                        if (locationItem.fullName) {
                            div.innerHTML = locationItem.fullName;
                        } else {
                            div.innerHTML = locationItem.adr_address;
                        }
                        setNatjecanjeLocation(div.innerText);
                        setNatjecanjePlace(locationItem);
                    } else {
                        setNatjecanjeLocation(locationItem);
                    }
                }
                if (firstResult.data.competition.sequence) {
                    setSequence(firstResult.data.competition.sequence);
                }
                if (firstResult.data.competition.sequenceNumber) {
                    setSequenceNumber(firstResult.data.competition.sequenceNumber);
                }
                if (firstResult.data.competition.note) {
                    setNote(firstResult.data.competition.note);
                }
                if (firstResult.data.competition.disciplines) {
                    setIzabraneDisciplinePlivanjeAtletika(firstResult.data.competition.disciplines.map((oneDisc) => {
                        return {
                            value: oneDisc,
                            label: oneDisc
                        }
                    }));
                }
            })

            axios.get(`${process.env.REACT_APP_MAIN_URL}/admin/get-competition-teams?competitionId=${params.id}`).then((result) => {
                let teams = result.data.teams;
                setCompetitionTeams(teams)
            }).catch((e) => {
                console.log(e)
            })
        }
    }, [])


    if (!competition) {
        return null;
    }

    handleGooglePlaces();


    let isAtletikaPlivanje = competition.sport.name === "Atletika" || competition.sport.name === "Plivanje";
    let hasDisciplines = competitionTeams && competitionTeams.length > 0 && competitionTeams[0].disciplines && competitionTeams[0].disciplines.length > 0;
    let disciplinesArray = [];
    if (hasDisciplines) {
        competitionTeams.map((oneTeam) => {
            if (oneTeam.disciplines && oneTeam.disciplines.map) {
                oneTeam.disciplines.map((oneDiscipline) => {
                    oneDiscipline.discipline.map((singleDiscipline) => {
                        if (!disciplinesArray.includes(singleDiscipline)) {
                            disciplinesArray.push(singleDiscipline);
                        }
                    })
                })
            }
        })
    }
    let playersWithDisciplinesArray = []
    disciplinesArray.map((myDiscipline) => {
        let players = []
        competitionTeams.map((oneTeam) => {
            if (oneTeam.disciplines && oneTeam.disciplines.map) {
                oneTeam.disciplines.map((oneDiscipline) => {
                    oneDiscipline.discipline.map((singleDiscipline) => {
                        if (singleDiscipline === myDiscipline) {
                            let isApproved = false;
                            oneTeam.players.map((myPlayer) => {
                                myPlayer.competitionApproval.map((oneApproval) => {
                                    if (oneApproval.competitionId === params.id && oneApproval.isApproved === true && myPlayer._id === oneDiscipline.player) {
                                        isApproved = true;
                                    }
                                })
                            })
                            if (isApproved) {
                                players.push(oneDiscipline.player);
                            }
                        }
                    })
                })
            }
        })
        playersWithDisciplinesArray.push({
            discipline: myDiscipline,
            players: players
        })
    })
    return (
        <Fragment>
            <NewSponzorModal
                toggle={() => {
                    setIsNewSponsorModalOpen(!isNewSponsorModalOpen);
                }}
                editSponsor={editSponsor}
                isOpen={isNewSponsorModalOpen}
                sponsors={sponsors}
                competition={competition}
                setSponsors={setSponsors}
            />

            <Card>
                <CardHeader>
                    <CardTitle tag='h4'>Unos detalja natjecanja</CardTitle>
                </CardHeader>

                <CardBody>
                    <Row>
                        <Col className='mb-3' md='6' sm='12'>
                              <span style={{}} className={"text-center justify-content-center"}>
                                Lokacija natjecanja
                              </span>
                            <Input
                                id={"lokacija-natjecanja-input"}
                                theme={selectThemeColors}
                                className='react-select'
                                classNamePrefix='select'
                                value={natjecanjeLocation}
                                onChange={(event) => {
                                    setNatjecanjeLocation(event.target.value)
                                }}
                                name='clear'
                                isClearable={false}
                            />
                        </Col>
                        <Col className='mb-3' md='6' sm='12'>
                            <span style={{}} className={"text-center justify-content-center"}>
                                Napomene vezane uz lokaciju
                              </span>
                            <Input
                                className='react-select'
                                value={note}
                                onChange={(data) => {
                                    setNote(data.target.value)
                                }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className='mb-3' md='6' sm='12'>
                              <span style={{}} className={"text-center justify-content-center"}>
                                Sekvenca
                              </span>
                            <Input
                                id={"sekvenca-input"}
                                theme={selectThemeColors}
                                className='react-select'
                                classNamePrefix='select'
                                invalid={validationFailed && sequence === ""}
                                value={sequence}
                                onChange={(event) => {
                                    setSequence(event.target.value)
                                }}
                                name='clear'
                                isClearable={false}
                            />
                        </Col>
                        <Col className='mb-1' md='6' sm='12'>
                            <span>Broj sekvence</span>
                            <Input
                                id={"sekvenca-broj-input"}
                                theme={selectThemeColors}
                                type={"number"}
                                className='react-select'
                                classNamePrefix='select'
                                invalid={validationFailed && sequenceNumber === ""}
                                value={sequenceNumber}
                                onChange={(event) => {
                                    setSequenceNumber(event.target.value)
                                }}
                                name='clear'
                                isClearable={false}
                            />
                        </Col>
                    </Row>
                    {competition.sport && isAtletikaPlivanje &&
                    <Row>
                        <Col className='mb-3' md='6' sm='12'>
                              <span style={{}} className={"text-center justify-content-center"}>
                                Discipline
                              </span>
                            <Select
                                theme={selectThemeColors}
                                className='react-select'
                                classNamePrefix='select'
                                value={izabraneDisciplinePlivanjeAtletika}
                                isMulti
                                styles={{
                                    control: styles => ({
                                        ...styles,
                                        borderColor: (validationFailed && izabraneDisciplinePlivanjeAtletika === "") ? 'red' : styles.borderColor,
                                        '&:hover': {
                                            borderColor: (validationFailed && izabraneDisciplinePlivanjeAtletika === "") ? 'red' : styles['&:hover'].borderColor
                                        }
                                    })
                                }}
                                onChange={(data) => {
                                    setIzabraneDisciplinePlivanjeAtletika(data)
                                }}
                                name='clear'
                                options={competition.sport.name === "Plivanje" ? disciplinePlivanje : (competition.sex === "M" ? disciplineAtletikaM : disciplineAtletikaZ)}
                                isClearable={false}
                            />
                        </Col>
                    </Row>
                    }
                </CardBody>
            </Card>
            {hasDisciplines && playersWithDisciplinesArray.length > 0 &&
            <Card>
                <CardHeader>
                    <CardTitle tag='h4'>Discipline</CardTitle>
                </CardHeader>
                <CardBody>
                    {playersWithDisciplinesArray.map((oneDiscipline) => {
                        let playersString = "";
                        oneDiscipline.players.map((onePlayerId) => {
                            competitionTeams.map((oneTeam) => {
                                oneTeam.players.map((onePlayer) => {
                                    if (onePlayer._id === onePlayerId) {
                                        playersString = playersString + onePlayer.name + " " + onePlayer.surname + " (" + oneTeam.shortName + "),  "
                                    }
                                })
                            })
                        })
                        playersString = playersString.substring(0, playersString.length - 3)
                        return <div>
                            <h6>{oneDiscipline.discipline} (Broj odobrenih
                                prijava: {oneDiscipline.players.length}):</h6> {playersString}<br/>
                            <br/>
                            <br/>
                        </div>
                    })}

                </CardBody>
            </Card>
            }
            <Card style={{
                overflowY: "scroll"
            }}>
                <DataTable style={{paddingBottom: "30px"}}
                    noHeader
                    responsive
                    subHeader
                    columns={columns}
                    className='react-dataTable'
                    noDataComponent="Zasad nema sponzora"
                    data={sponsors}
                    subHeaderComponent={
                        <CustomHeader
                            name={"Sponzori"}
                            new={"Novi sponzor"}
                            onClick={() => {
                                setEditSponsor(null)
                                setIsNewSponsorModalOpen(true);
                            }
                            }
                        />
                    }
                />
            </Card>
            <FooterButtons
                backClick={() => {
                    history.goBack()
                }}
                forwardClick={() => {
                    if (sequence === "" ||
                        sequenceNumber === "" ||
                        (isAtletikaPlivanje && izabraneDisciplinePlivanjeAtletika.length === 0)) {
                        setValidationFailed(true);
                    } else {
                        let add = "add";
                        if (competition.startDate && competition.location) {
                            add = "edit"
                        }
                        let disciplinesSet = [];
                        if (izabraneDisciplinePlivanjeAtletika && izabraneDisciplinePlivanjeAtletika.map) {
                            izabraneDisciplinePlivanjeAtletika.map((oneDiscipline) => {
                                disciplinesSet.push(oneDiscipline.value);
                            })
                        }
                        axios.post(`${process.env.REACT_APP_MAIN_URL}/admin/${add}-competition-details`, {
                            sponsors,
                            note,
                            location: natjecanjePlace,
                            halfDuration: 15,
                            competitionId: params.id,
                            sequence,
                            sequenceNumber,
                            izabraneDisciplinePlivanje: disciplinesSet,
                            discipline: disciplinesSet,
                            disciplines: disciplinesSet,
                        }).then((result) => {
                            history.push(`/natjecanja/detalji/korak-3-faze/${params.id}`);
                        }).catch((e) => {
                            MySwal.fire({
                                icon: 'warning',
                                title: 'Pogreška',
                                text: 'Nešto je pošlo po krivu. Molimo probajte ponovno',
                                customClass: {
                                    confirmButton: 'btn btn-success'
                                }
                            })
                        });

                        /*    dispatch({
                                type: "NATJECANJE_STEP1",
                                newNatjecanjeStep1Data: {
                                    currentSeason: natjecanjeLocation,
                                    currentLeague: openingDate,
                                    currentSport: halfTimeDuration,
                                    currentSequence,
                                    name
                                }
                            });*/
                    }
                }}
            />



        </Fragment>
    )
}


export default DetaljiNatjecanjaStep2;